import ScToast from "@/src/components/ui-kit/toast";
import React from "react";
import Toast, { BaseToastProps } from "react-native-toast-message";

export const toastConfig = {
  success: (props: BaseToastProps) => (
    <ScToast
      text1={props.text1 || ""}
      text2={props.text2}
      type="success"
      onClose={() => Toast.hide()}
    />
  ),

  error: (props: BaseToastProps) => (
    <ScToast
      text1={props.text1 || ""}
      text2={props.text2}
      type="error"
      onClose={() => Toast.hide()}
    />
  ),

  // Registering this is what makes `Toast.show({ type: "info" })` visible at
  // all — an unregistered type renders nothing, so the partial-invite result,
  // the event waitlist notice and the life-update warning were all silent.
  info: (props: BaseToastProps) => (
    <ScToast
      text1={props.text1 || ""}
      text2={props.text2}
      type="info"
      onClose={() => Toast.hide()}
    />
  ),
};
